import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Select,
  message,
  Button,
  Tag,
  Tooltip,
  Spin,
  Checkbox,
} from "antd";
import React, { useCallback, useState } from "react";
import MotionHoc from "../../../utils/MotionHoc";
import {
  SearchOutlined,
  SendOutlined,
  ReloadOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../../assets/font/THSarabunNew-normal";
import "../../../assets/font/THSarabunNew-bold";
import {
  HEADERS_EXPORT_BEN,
  POST_SEARCH_OLD_CONTNO,
  POST_WARP_SEND_LAWSUIT,
} from "../../API/apiUrls";
import DateCustom from "../../../hook/DateCustom";

import {
  OPTIONS_FILTER_STATUS,
  OPTIONS_LAWYER_JOBS,
  OPTIONS_TYPE,
} from "./constant/SelectOption";

const Main = () => {
  const [, convertDateThaiShort] = DateCustom();
  const userId = parseInt(localStorage.getItem("USER_ID"));

  const [loading, setLoading] = useState(false);
  const [arrData, setArrData] = useState([]);
  const [dataType, setDataType] = useState();
  const [lawyerCode, setLawyerCode] = useState();
  const [filterStatus, setFilterStatus] = useState("all");
  const [excludeNV, setExcludeNV] = useState(false);

  const onQueryData = () => {
    if (!dataType || !lawyerCode) {
      message.error("กรุณาเลือกข้อมูลให้ครบ");
      return;
    }
    loadData();
  };

  const loadData = useCallback(async () => {
    setLoading(true);
    const payload = {
      DATA_TYPE: dataType, // rpsl | vsfhp
      FOLLOWCOD: lawyerCode, // ทนาย
      SDATE: "2015-01-01", // วันเริ่ม
      FDATE: dayjs().format("YYYY-MM-DD"), // วันสิ้นสุด
    };

    try {
      const { status, data } = await axios.post(
        POST_SEARCH_OLD_CONTNO,
        payload,
        { headers: HEADERS_EXPORT_BEN },
      );

      if (status !== 200) {
        throw new Error(`HTTP ${status}`);
      }

      if (!Array.isArray(data.data) || data.data.length === 0) {
        message.warning("ไม่มีข้อมูล");
        setArrData([]);
        return;
      }

      let i = 1;
      const newData = data.data.map((item) => ({ ...item, key: i++ }));
      setArrData(newData);
    } catch (error) {
      const httpStatus = error?.response?.status;
      const serverMsg = error?.response?.data?.message;

      message.error(
        serverMsg ||
          `ไม่สามารถดึงข้อมูลได้ (${httpStatus ?? "-"}) ติดต่อผู้ดูแลระบบ`,
      );
      setArrData([]);
    } finally {
      setLoading(false);
    }
  }, [dataType, lawyerCode]);

  const sendData = useCallback(
    async (dataLawsuit) => {
      const lawyer = OPTIONS_LAWYER_JOBS.find((o) => o.value === lawyerCode);
      const payload = {
        CONTNO: dataLawsuit.CONTNO,
        userId: userId,
        userIdLawyer: lawyer?.id,
        RUNNO: dataLawsuit.RUNNO,
        DATA_TYPE: dataType,
      };
      console.log("dataLawsuit", dataLawsuit);
      console.log("payload", payload);
      setLoading(true);
      try {
        const { status } = await axios.post(POST_WARP_SEND_LAWSUIT, payload, {
          headers: HEADERS_EXPORT_BEN,
        });

        if (status !== 200) {
          throw new Error(`HTTP ${status}`);
        }

        message.success("บันทึกข้อมูลสำเร็จ");
        await loadData();
      } catch (error) {
        const httpStatus = error?.response?.status;
        const serverMsg = error?.response?.data?.message;

        message.error(
          serverMsg ||
            `ไม่สามารถบันทึกข้อมูลได้ (${httpStatus ?? "-"}) ติดต่อผู้ดูแลระบบ`,
        );
      } finally {
        setLoading(false);
      }
    },
    [loadData, dataType, lawyerCode, userId],
  );

  const getFollowerLabel = (record) => {
    const lawyer = OPTIONS_LAWYER_JOBS.find(
      (o) => o.value === record.FOLLOWCOD,
    );
    return record.lawyer?.lawyerName || lawyer?.label || "-";
  };

  const filteredData = arrData.filter((item) => {
    if (filterStatus === "yes" && !item.lawyer) return false;
    if (filterStatus === "no" && !!item.lawyer) return false;
    if (excludeNV && /[NV]/i.test(item.CONTNO)) return false;

    return true;
  });

  const renderStatusProcess = (record) => {
    if (!record) return null;

    return (
      <Tag color="orange" style={{ textAlign: "center", padding: "2px 10px" }}>
        {record.lawyer?.currentStatusText ?? "ยังไม่ส่งฟ้อง"}
      </Tag>
    );
  };

  const columns = [
    {
      title: "ลำดับ",
      align: "center",
      dataIndex: "key",
      render: (text, record) => (
        <span style={{ fontWeight: "bold" }}>{record.key}</span>
      ),
    },
    {
      title: "เลขที่แจ้ง",
      align: "center",
      dataIndex: "RUNNO",
    },
    {
      title: "สาขา",
      align: "center",
      dataIndex: "LOCAT",
    },
    {
      title: "เลขสัญญา",
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: 14 }}>{record.CONTNO}</span>
      ),
    },
    {
      title: "ลูกค้า",
      align: "center",
      render: (text, record) => (
        <div>
          <div style={{ fontWeight: "bold" }}>{record.CNAME}</div>
          <div style={{ fontSize: 12, color: "#888" }}>{record.CUSCOD}</div>
        </div>
      ),
    },
    {
      title: "ทรัพย์",
      align: "center",
      render: (text, record) => (
        <div style={{ lineHeight: 1.6 }}>
          <div>
            {record.TYPE} {record.MODEL}
          </div>
          <div style={{ fontSize: 12, color: "#888" }}>
            ตัวถัง: {record.STRNO || "-"}
          </div>
          <div style={{ fontSize: 12, color: "#888" }}>
            ทะเบียน: {record.REGNO || "-"}
          </div>
        </div>
      ),
    },
    {
      title: "วันที่แจ้ง",
      align: "center",
      render: (text, record) =>
        record.NOTEDT ? convertDateThaiShort(record.NOTEDT) : "-",
    },
    {
      title: "ผู้ติดตาม",
      align: "center",
      render: (text, record) => (
        <div>
          <div>{getFollowerLabel(record)}</div>
          <div style={{ fontSize: 12, color: "#888" }}>
            {record.FOLLOWCOD}
          </div>
        </div>
      ),
    },
    {
      title: "สถานะฟ้อง",
      align: "center",
      render: (text, record) => (
        <Tag color={record.flagSue ? "green" : "default"}>
          {record.flagSue ? "ส่งฟ้องแล้ว" : "ยังไม่ส่งฟ้อง"}
        </Tag>
      ),
    },
    {
      title: "สถานะงานปัจจุบัน",
      align: "center",
      render: (text, record) => <>{renderStatusProcess(record)}</>,
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (text, record) => {
        const noJobYet = record.flagSue;

        return (
          <div style={{ lineHeight: 1.6 }}>
            <Tooltip
              title={`${noJobYet ? "สัญญานี่ส่งฟ้องไปแล้ว !" : "คลิกเพื่อฟ้องสัญญานี้"}`}
            >
              <Button
                type="primary"
                ghost
                icon={<SendOutlined />}
                size="small"
                onClick={() => {
                  sendData(record);
                }}
                loading={loading}
                disabled={noJobYet}
              >
                ส่งฟ้อง
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const handleExportPDF = () => {
    if (!filteredData.length) {
      message.warning("ไม่มีข้อมูลสำหรับ Export");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const pageWidth = doc.internal.pageSize.getWidth();
    const now = dayjs().format("DD/MM/YYYY HH:mm:ss");

    const drawHeader = (pageNum) => {
      doc.setFont("THSarabunNew", "bold");
      doc.setFontSize(16);
      doc.text("รายงานสัญญาเก่า", pageWidth / 2, 8, { align: "center" });
      doc.setFont("THSarabunNew", "normal");
      doc.setFontSize(12);
      doc.text(`วันที่พิมพ์ ${now}`, 8, 16);
      doc.text(`หน้าที่ ${pageNum}`, pageWidth - 8, 16, { align: "right" });
    };

    const tableHead = [
      "ลำดับ",
      "เลขที่แจ้ง",
      "สาขา",
      "เลขสัญญา",
      "ลูกค้า",
      "ทรัพย์",
      "วันที่แจ้ง",
      "ผู้ติดตาม",
    ];

    const tableBody = filteredData.map((record) => [
      record.key,
      record.RUNNO || "-",
      record.LOCAT || "-",
      record.CONTNO || "-",
      `${record.CNAME || "-"}\n${record.CUSCOD || ""}`,
      `${record.TYPE || ""} ${record.MODEL || ""}\nตัวถัง: ${
        record.STRNO || "-"
      }\nทะเบียน: ${record.REGNO || "-"}`,
      record.NOTEDT ? convertDateThaiShort(record.NOTEDT) : "-",
      `${getFollowerLabel(record)}\n${record.FOLLOWCOD || ""}`,
    ]);

    doc.autoTable({
      startY: 20,
      head: [tableHead],
      body: tableBody,
      headStyles: {
        font: "THSarabunNew",
        fillColor: [52, 73, 94],
        textColor: 255,
        halign: "center",
        fontStyle: "bold",
        fontSize: 11,
      },
      styles: {
        font: "THSarabunNew",
        fontSize: 10,
        cellPadding: 1.5,
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        4: { halign: "left" },
        5: { halign: "left" },
      },
      alternateRowStyles: { fillColor: [235, 245, 255] },
      didDrawPage: () =>
        drawHeader(doc.internal.getCurrentPageInfo().pageNumber),
      margin: { top: 20, left: 5, right: 5 },
    });

    doc.save(`รายงานสัญญาเก่า_${dayjs().format("DDMMYYYY")}.pdf`);
  };

  return (
    <Spin spinning={loading} size="large" tip="Loading...">
      <Card style={{ marginBottom: 8 }}>
        <Row gutter={[8, 8]}>
          <Col span={24} style={{ textAlign: "start" }}>
            <Space direction="horizontal" size={10} wrap>
              <Select
                style={{ width: 160, marginBottom: 5 }}
                placeholder="เลือกสัญญา"
                onChange={setDataType}
                popupMatchSelectWidth={false}
                options={OPTIONS_TYPE}
                value={dataType}
                size="large"
              />
              <Select
                style={{ width: 160, marginBottom: 5 }}
                placeholder="เลือกทนาย"
                onChange={setLawyerCode}
                popupMatchSelectWidth={false}
                options={OPTIONS_LAWYER_JOBS}
                value={lawyerCode}
                size="large"
              />
              <Select
                style={{ width: 160, marginBottom: 5 }}
                placeholder="สถานะ"
                onChange={setFilterStatus}
                popupMatchSelectWidth={false}
                options={OPTIONS_FILTER_STATUS}
                value={filterStatus}
                size="large"
              />
              <Checkbox
                checked={excludeNV}
                onChange={(e) => setExcludeNV(e.target.checked)}
                style={{ marginBottom: 5 }}
              >
                ตัดเลขสัญญาที่มี N, V ออก
              </Checkbox>

              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: 8,
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                  marginBottom: 5,
                }}
                onClick={onQueryData}
              >
                ค้นหา
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => {
                  setDataType(null);
                  setLawyerCode(null);
                  setFilterStatus("all");
                  setExcludeNV(false);
                  setArrData([]);
                }}
                color="red"
                variant="outlined"
                style={{
                  marginBottom: 5,
                }}
              >
                ล้าง
              </Button>
              <Button
                icon={<FilePdfOutlined />}
                onClick={handleExportPDF}
                disabled={!filteredData.length}
                style={{
                  marginBottom: 5,
                  color: "#c0392b",
                  borderColor: "#c0392b",
                }}
              >
                Export PDF
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>

      <Card>
        <Table
          rowKey="key"
          columns={columns}
          dataSource={filteredData}
          loading={loading}
          scroll={{ x: true }}
          pagination={{ showSizeChanger: true }}
          footer={() => (
            <span>จำนวนสัญญาทั้งหมด: {filteredData.length} รายการ</span>
          )}
        />
      </Card>
    </Spin>
  );
};

const MainOldContno = MotionHoc(Main);
export default MainOldContno;
